import Joi from 'joi';

import { AppSubjectEnum } from '../../../../shared/modules/authz/enums/app-subject.enum';
import { updateCompanyCustomerContactSchema } from '../../../../shared/modules/contacts/validators/schemas/update-company-customer-contact.schema';
import { updateIndividualCustomerContactSchema } from '../../../../shared/modules/contacts/validators/schemas/update-individual-customer-contact.schema';
import { updateTenantDriverSchema } from '../../../drivers/validators/schemas/update-tenant-driver.schema';
import { createPoliciesAssignSchema } from '../../../policies/validators/schemas/policies-assign.schema';
import { createTagsSchema } from '../../../tags/validators/schemas/create-tags.schema';
import { CustomerTypeEnum } from '../../enums/customer-type.enum';

/**
 * Schema for existing customer record validation.
 */
export const updateCustomerSchema = () =>
  Joi.object({
    id: Joi.alternatives().conditional(Joi.any().valid(null), {
      then: Joi.invalid(null).messages({
        'any.invalid': 'validations|customer-id|cannot-be-null',
      }),
      otherwise: Joi.number().required().messages({
        'any.required': 'validations|customer-id|required',
        'number.base': 'validations|customer-id|must-be-number',
      }),
    }),

    // Type
    type: Joi.alternatives()
      .conditional(Joi.any().valid(null), {
        then: Joi.invalid(null).messages({
          'any.invalid': 'validations|customer-type|cannot-be-null',
        }),
        otherwise: Joi.string()
          .valid(...Object.values(CustomerTypeEnum))
          .required()
          .messages({
            'any.required': 'validations|customer-type|required',
            'any.only': 'validations|customer-type|invalid-value',
          }),
      })
      .prefs({ abortEarly: true }),

    // Contact
    contact: Joi.object().when('type', {
      is: Joi.valid(CustomerTypeEnum.INDIVIDUAL),
      then: updateIndividualCustomerContactSchema(18),
      otherwise: Joi.object().when('type', {
        is: Joi.valid(CustomerTypeEnum.COMPANY),
        then: updateCompanyCustomerContactSchema(),
      }),
    }),

    // Driver
    driver: updateTenantDriverSchema().allow(null),

    notes: Joi.string().allow(null, '').messages({
      'string.base': 'validations|customer-notes|must-be-string',
    }),

    externalReference: Joi.string().allow(null, '').messages({
      'string.base': 'validations|customer-external-reference|must-be-string',
    }),

    // Tags
    tags: createTagsSchema().messages({
      'array.base': 'validations|customer-tags|invalid-value',
    }),

    policies: createPoliciesAssignSchema(AppSubjectEnum.CUSTOMER),

    files: Joi.any().allow(null),
  })
    // Ignore extra fields
    .unknown();
